import { Asterisk } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const items = t.marquee;

  const row = (hidden) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center gap-10 pe-10">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-10 whitespace-nowrap font-display text-2xl font-semibold text-ink/75 sm:text-3xl">
          {item}
          <Asterisk className="h-6 w-6 text-terra" />
        </span>
      ))}
    </div>
  );

  return (
    <div className="overflow-hidden border-y border-line bg-cream py-7" data-testid="editorial-marquee">
      <div className="marquee-track items-center">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
};
